import React from "react";
import "./Button.css";

/**
 * Square-arrow expanding button.
 *
 * Props:
 *  - children: label text (default: "Explore")
 *  - onClick / href: use one or the other
 *  - color:   accent fill color for square/expanded band (default "#e11d1d")
 *  - outline: outline + initial label color (default "#ffffff")
 *  - className, type, ...rest
 */
const Button = ({
  children = "Explore",
  onClick,
  href,
  color = "#e11d1d",
  outline = "#ffffff",
  className = "",
  type = "button",
  ...rest
}) => {
  const style = { "--cta-accent": color, "--cta-outline": outline };

  const content = (
    <>
      {/* expanding band (starts as filled square) */}
      <span className="cta-btn__bg" aria-hidden="true" />
      {/* arrow stays fixed, centered within the original square */}
      <span className="cta-btn__arrow" aria-hidden="true" />
      {/* label above the band */}
      <span className="cta-btn__label">{children}</span>
    </>
  );

  return href ? (
    <a href={href} className={`cta-btn ${className}`} style={style} {...rest}>
      {content}
    </a>
  ) : (
    <button
      type={type}
      onClick={onClick}
      className={`cta-btn ${className}`}
      style={style}
      {...rest}
    >
      {content}
    </button>
  );
};

export default Button;
